export default {
    CCDC: 'CCDC',
    VT: 'VT',
  };